const LAYOUT_WIDTH = 1000
const LAYOUT_HEIGHT = 2000


export {
    LAYOUT_WIDTH,
    LAYOUT_HEIGHT,
}
